import EventEmitter from './EventEmitter.js'
import * as THREE from 'three'
import Experience from './../Experience.js'
import  gsap  from "gsap"
import makeDom from '../utils/MakeDom.js'


export default class MousePos extends EventEmitter{
    constructor(){
        super()
        this.experience=new Experience()
        this.sizes=this.experience.sizes
        this.time=this.experience.time
        // this.canvas = this.experience.canvas
        this.canvas=window

        //setup
        this.x=0.5
        this.y=0.5
        this.smoothx=0.5
        this.smoothy=0.5
        this.positionRel= new THREE.Vector2(0,1)
        this.smoothPos= new THREE.Vector2(0,1)
        this.lastPos = new THREE.Vector2(0,1)
        this.smoothRel= new THREE.Vector2()
        this.smoothScrolly=0.5
        this.touchscreen=false
        this.factor=0.001 * this.time.delta //SPEED
        this.touchStart = new THREE.Vector2()
        this.touchEnd = new THREE.Vector2()
        this.touchMove = new THREE.Vector2()
        this.touchFactor = new THREE.Vector2(4,100)
        this.clickStart = new THREE.Vector2()
        this.clickEnd = new THREE.Vector2()
        this.clickMove = new THREE.Vector2()
        this.clickFactor = new THREE.Vector2(4,100)
        this.scrollY = 0
        this.scrollYPrev=0
        this.moveEndX=true
        this.moveEndY=true
        this.hold=false
        this.automove=false
        // this.counter=500
        const container=document.getElementsByClassName('webglContainer')
        // console.log (container)
        this.touch=new makeDom({
            tag:'div',
            class:['touchzone','hided'],
            parent:container[0]}
        )
        // console.log(this.touch)
        this.joystick=new makeDom({
            tag:'div',
            class:['joystick'],
            parent:this.touch.element}
        )
        this.setup()
        this.time.on('tick',()=>{this.smooth()})
    }
    setup(){
        this.canvas.addEventListener('mousedown',(event)=>{
            this.moveEndX=false
            this.moveEndY=false
            this.x = Math.min(Math.max(event.clientX / this.sizes.width * 2 - 1,-1),1)
            this.y = Math.min(Math.max(- (event.clientY / this.sizes.height) * 2 + 1,-1),1)
            this.clickStart.x=this.x
            this.clickStart.y=this.y
            // this.lastPos.x=this.x
            // this.lastPos.y=this.y
            this.hold=true
            // this.touch.hide()
            // console.log('mousedown' + this.x)
            // this.counter=500
        })
        // LISTENER PER MOUSEMOVE
        this.canvas.addEventListener('mousemove', (event) =>
        {
            if (!this.automove && this.hold) {
                // console.log(this.automove+' e hold '+this.hold)
                this.touchscreen=false
                this.x = Math.min(Math.max(event.clientX / this.sizes.width * 2 - 1,-1),1)
                this.y = Math.min(Math.max(- (event.clientY / this.sizes.height) * 2 + 1,-1),1)
                // this.trigger('move')
                // if (!this.hold){
                //     this.clickStart.x=this.x
                //     this.clickStart.y=this.y
                //     console.log(this.x)
                // }
                // if (!this.moveEndX){
                    this.positionRel.x=this.minMax(this.x-this.clickStart.x+this.lastPos.x,-1,1) //+ diffx*this.factor
                    this.positionRel.y=this.minMax(this.y-this.clickStart.y+this.lastPos.y,-1,1) //+ diffy*this.factor
                    // this.counter++
                    // if (this.counter>=500){
                    //     this.counter=0
                    //     console.log('x= '+Math.round(this.x*100)+' - '+Math.round( this.clickStart.x*100)+' + '+Math.round(this.lastPos.x*100)+' = '+Math.round(this.positionRel.x*100))
                    // }
                // }
            }
        })
        this.canvas.addEventListener('mouseup',(event)=>{
            this.hold=false
            this.lastPos.x=this.positionRel.x
            this.lastPos.y=this.positionRel.y
            // console.log(this.positionRel.x)
        })
        this.canvas.addEventListener('mouseleave',(event)=>{
            this.hold=false
        })
// =======================================================================   prova touch

        this.canvas.addEventListener('touchstart',(event)=>{
            if (event.targetTouches.length == 2) {
                event.preventDefault()
                const touch = event.targetTouches[0]
                // this.touchMove(touch.pageX,touch.pageY)
                // this.joystick.element.style.left= this.minMax(touch.pageX -this.touchStart.x+75,0,150)+'px';
                // this.joystick.element.style.top= this.minMax(touch.pageY -this.touchStart.y+75,0,150)+'px';
                // this.touchMove.x=this.minMax(touch.pageX -this.touchStart.x,-200,200)/-5000
                // this.touchMove.y=this.minMax(touch.pageY -this.touchStart.y,-200,200)/5000
                this.moveEndX=false
                this.moveEndY=false

                this.x = Math.min(Math.max(touch.clientX / this.sizes.width * 2 - 1,-1),1)
                this.y = Math.min(Math.max(- (touch.clientY / this.sizes.realHeight) * 2 + 1,-1),1)
                this.clickStart.x=this.x
                this.clickStart.y=this.y
                this.hold=true
            } //else if (event.targetTouches.length == 2) console.log(event.targetTouches)

        },{passive:false})
        this.canvas.addEventListener('touchmove', (event) =>
        {
            // alert('touchhhh')
            if (event.targetTouches.length == 2) {
                event.preventDefault()
                this.scrollY = window.scrollY
                const touch = event.targetTouches[0]
                // this.touchMove(touch.pageX,touch.pageY)
                // this.joystick.element.style.left= this.minMax(touch.pageX -this.touchStart.x+75,0,150)+'px';
                // this.joystick.element.style.top= this.minMax(touch.pageY -this.touchStart.y+75,0,150)+'px';
                // this.touchMove.x=this.minMax(touch.pageX -this.touchStart.x,-200,200)/-5000
                // this.touchMove.y=this.minMax(touch.pageY -this.touchStart.y,-200,200)/5000
                this.x = Math.min(Math.max(touch.clientX / this.sizes.width * 2 - 1,-1),1)
                this.y = Math.min(Math.max(- (touch.clientY / this.sizes.realHeight) * 2 + 1,-1),1)
                // alert(touch.clientY)
                this.positionRel.x=this.minMax(this.x-this.clickStart.x+this.lastPos.x,-1,1) //+ diffx*this.factor
                this.positionRel.y=this.minMax(this.y-this.clickStart.y+this.lastPos.y,-1,1) //+ diffy*this.factor
                // console.log(touch.pageY)
                this.moveEndX=false
                this.moveEndY=false
            }

            // if (!this.automove && this.hold) {
            //     // console.log(this.automove+' e hold '+this.hold)
            //     // this.touchscreen=false
            // }
        },{passive:false}
        )
        this.canvas.addEventListener('touchend',(event)=>{
            this.hold=false
            this.lastPos.x=this.positionRel.x
            this.lastPos.y=this.positionRel.y
        })
        // this.canvas.addEventListener('mouseleave',(event)=>{
        //     this.hold=false
        // })

//==============================================================================   fine prova touch

        // // LISTENER PER Mouse click
        // this.canvas.addEventListener('click', (event) =>
        // // window.addEventListener('click', (event) =>
        // {
        //     this.touch=false
        //     // this.x = Math.min(Math.max(event.offsetX / this.sizes.width * 2 - 1,-1),1)
        //     // this.y = Math.min(Math.max(- (event.offsetY / this.sizes.height) * 2 + 1,-1),1) 
        //     // const pos= new THREE.Vector2(this.x,this.y)
        //     // this.trigger('click')
        // })
        // LISTENER PER scrollY
        this.canvas.addEventListener('scroll', (event) =>{
            this.trigger('scroll')
        })
        
        // LISTENER PER TouchStart
        // this.canvas.addEventListener("touchstart", (event) =>{
        //     this.touchscreen=true
        //     this.touch.show()
        //     setTimeout(()=>{if (!this.hold) {this.touch.hide()}},1000)
        // })
        window.addEventListener('scroll',()=>
        {
            this.scrollY = window.scrollY
        })
        // this.joystick.element.addEventListener("touchstart",(event)=>{
        //     this.touchStart.x=event.changedTouches[0].pageX 
        //     this.touchStart.y=event.changedTouches[0].pageY
        //     this.hold=true
        //     // event.preventDefault()
            
        // },{passive:false})
        // this.joystick.element.addEventListener("touchmove",(event)=>{
        //     event.preventDefault()
        //     if (event.targetTouches.length == 1) {
        //         const touch = event.targetTouches[0]
        //         // this.touchMove(touch.pageX,touch.pageY)
        //         this.joystick.element.style.left= this.minMax(touch.pageX -this.touchStart.x+75,0,150)+'px';
        //         this.joystick.element.style.top= this.minMax(touch.pageY -this.touchStart.y+75,0,150)+'px';
        //         this.touchMove.x=this.minMax(touch.pageX -this.touchStart.x,-75,75)/-5000
        //         this.touchMove.y=this.minMax(touch.pageY -this.touchStart.y,-75,75)/5000
        //         this.moveEndX=false
        //         this.moveEndY=false
        //     }
        // })
        // this.joystick.element.addEventListener("touchend",(event)=>{
        //     const touch = event.targetTouches[0]
        //     // console.log(this.joystick.element.style)
        //     this.joystick.element.style.left='75px';
        //     this.joystick.element.style.top='75px';    
        //     this.hold=false
        //     setTimeout(()=>{if (!this.hold) {this.touch.hide()}},1000)

        // })
    }

    smooth(){
        if (this.touchscreen && this.hold){
            // console.log(this.touchMove)
            this.positionRel.x+=this.touchMove.x
            this.positionRel.x= this.minMax(this.positionRel.x,-1,1)
            console.log('mai')
            this.positionRel.y+=this.touchMove.y
            this.positionRel.y= this.minMax(this.positionRel.y,-1,1)
            // console.log(this.positionRel.x)
        }
        if (!this.moveEndX){
            const diffx = this.positionRel.x - this.smoothPos.x
            if (Math.abs(diffx)>0.001 || this.hold){
                this.smoothPos.x+= diffx*this.factor
            }else {
                this.moveEndX=true
                // console.log('movendx true')
            }
        }
        if (!this.moveEndY){
            const diffy = this.positionRel.y - this.smoothPos.y
            if (Math.abs(diffy)>0.001 || this.hold){
                this.smoothPos.y+= diffy*this.factor
            }else {
                this.moveEndY=true
                // console.log('movendy true')
            }
        }

    }
    minMax(val,min,max){
        return Math.min(Math.max(val,min),max)
    }
    touchDefault(){
        this.touchFactor.set(4,100)
    }
    goToPoint(x,y){
        this.moveEndX=false
        this.moveEndY=false
        this.clickStart.x=0
        this.clickStart.y=0
        this.hold=true
        this.automove=true
        // this.easing='power3.inOut'
        gsap.to(this.positionRel,{x:x,duration:1,ease:'power3.inOut'})
        gsap.to(this.positionRel,{y:y,duration:1,ease:'power3.inOut',onComplete:()=>{
            this.hold=false
            // this.smoothPos= new THREE.Vector2(0,1)
            this.lastPos.x = x
            this.lastPos.y = y
            this.automove=false
        }})
        // this.positionRel.x=this.minMax(this.x-this.clickStart.x+this.lastPos.x,-1,1) //+ diffx*this.factor
        // this.positionRel.y=this.minMax(this.y-this.clickStart.y+this.lastPos.y,-1,1) //+ diffy*this.factor


    }
}